import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { TokenStorageService } from '@core/services/token-storage.service';
@Injectable({
  providedIn: 'root',
})
export class RolUserGuard implements CanActivate {
  constructor(private _tokenStorageService: TokenStorageService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const scopes = this._tokenStorageService.getRol();

    return true;
    if (!scopes.includes(state.url)) {
      this.router.navigate(['/']);
    }

    return of(scopes.includes(state.url));
  }
}
